export enum CartItemSlot {
  Primary,
  Secondary,
  Shipping,
  ShippingIntl,
  Trial,
  Subscription,
  Upsell,
  SemiAnnual,
}
